import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  getTrainHistories,
  updateDatasetFile,
  getProject,
} from "../../services/projectService";
import { getTrainLog } from "../../services/trainLogService";
import { startTrainProject } from "../../services/projectService";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  IconButton,
  LinearProgress,
  linearProgressClasses,
  styled,
} from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { t } from "i18next";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import { ITrainHistory, TrainLog } from "@types";
import LineChartComponent from "../LineChartComponent";
import LineChartComponent2 from "../LineChartComponent2";
import RefreshIcon from "@mui/icons-material/Refresh";
import { formatDateTime } from "../../utils/utils";
import { toast } from "react-toastify";
import TrainHistoryFilterModal from "./TrainHistoryFilterModal";
import { ContainedButtonStyles } from "../../styles/GlobalStyles";
import { AccuracyData } from "../../@types";
export default function TrainHistory() {
  const { id } = useParams();
  const [sortOption, setSortOption] = useState<string>("all");
  const [historyData, setHistoryData] = useState<ITrainHistory[]>([]);
  const [selectedRow, setSelectedRow] = useState<ITrainHistory>({
    id: -1,
    iteration: -1,
    project_id: -1,
    class_name: "",
    epoch: 0,
    imageCount: 0,
    accuracy: null,
    status: "",
    create_at: "",
    finish_at: null,
    trainLog_uuid: "",
    top: false,
  });
  const [accuracyData, setAccuracyData] = useState<TrainLog[]>([]); // 차트 데이터 상태
  const [startDate, setStartDate] = useState<string>(""); // 시작 날짜 상태 추가
  const [endDate, setEndDate] = useState<string>(""); // 종료 날짜 상태 추가
  // const [clickedEpoch, setClickedEpoch] = useState<number>(0);
  const [step, setStep] = useState<string>("");
  const [currentStep, setCurrentStep] = useState<string>("");
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  // const [isReset, setIsReset] = useState(false);
  const [filterOption, setFilterOption] = useState<HistoryFilterOption>({});
  const [selectedEpoch, setSelectedEpoch] = useState<AccuracyData | null>(null);

  const statusStyles = (status: string) => {
    if (status === "Finished") return { backgroundColor: "#DCFCE7" };
    if (status === "pending") return { backgroundColor: "#FEE2E2" };
    if (status === "failed") return { backgroundColor: "#FEE2E2" };
    return { backgroundColor: "gray", color: "#fff" };
  };

  // 정렬이 변경하면 조회
  useEffect(() => {
    const filteredData = async () => {
      const response = await getTrainHistories({
        id: Number(id),
        sortOption,
        filterOption,
        page: 1,
        size: 20,
      });
      if (response.trainHistory) {
        setHistoryData(response.trainHistory);
      }
    };
    filteredData();
    setFilterModalOpen(false);
  }, [sortOption, filterOption]); //isReset

  const columns: GridColDef[] = [
    { field: "id", headerName: t("Round"), width: 70 },
    { field: "class_name", headerName: t("Class"), width: 73 },
    { field: "create_at", headerName: t("TrainRequestTime"), width: 140 },
    { field: "finish_at", headerName: t("TrainEndTime"), width: 140 },
    // { field: "timeSpent", headerName: t("TimeSpent"), width: 87 },
    { field: "imageCount", headerName: t("ImageCount"), width: 84 },
    { field: "accuracy", headerName: t("Accuracy"), width: 84 },
    { field: "epoch", headerName: t("Epoch"), width: 84 },
    { field: "status", headerName: t("Status"), width: 140 },
  ];

  const handlePointClick = async (id: number) => {
    const clickedRow = historyData.find((row) => row.id === id) || {
      id: -1,
      iteration: -1,
      project_id: -1,
      class_name: "",
      epoch: 0,
      imageCount: 0,
      accuracy: null,
      status: "",
      create_at: "",
      finish_at: null,
      trainLog_uuid: "",
      top: false,
    };
    setSelectedRow(clickedRow);

    const trainLog_uuid = clickedRow.trainLog_uuid;
    if (trainLog_uuid) {
      try {
        const response = await getTrainLog(trainLog_uuid);
        const response1String = response.accuracy;

        let response1;
        try {
          response1 = JSON.parse(response1String);
        } catch (error) {
          console.error("Failed to parse response1:", error);
          return;
        }

        if (Array.isArray(response1)) {
          const transformedData: TrainLog[] = response1.map((item: any) => ({
            epoch: item.epoch,
            accuracy: item.accuracy !== null ? item.accuracy : 0,
          }));

          setAccuracyData(transformedData); // 특정 회차 클릭 시 accuracyData 업데이트
        } else {
          console.error("Parsed Response1 is not an array:", response1);
        }
      } catch (error) {
        console.error("Failed to fetch train log:", error);
      }
    } else {
      setAccuracyData([]); // 그래프 데이터 초기화
      console.log("trainLog_uuid is null, hiding the graph.");
      toast.error("학습 로그가 존재하지 않습니다.");
    }
  };

  const handleContinueTraining = async () => {
    // epoch가 0인 경우 알림 메시지 표시
    if (!selectedEpoch) {
      toast.error("Epoch이 0입니다. 유효한 Epoch을 선택해 주세요."); // 알림 메시지
      return; // 함수 종료
    }

    try {
      const label = selectedRow.class_name; // 선택된 클래스 이름
      const multi = label.includes("[") ? true : false; // 통합 모델 여부

      await updateDatasetFile(Number(id));

      await startTrainProject(
        Number(id),
        step,
        multi ? undefined : label,
        multi,
        selectedEpoch?.epoch // epoch 전달
      );
      console.log("학습 시작 요청 성공");
    } catch (error) {
      console.error("데이터셋 업데이트 중 오류 발생:", error);
    }
  };

  const handleSortChange = (event: SelectChangeEvent<string>) => {
    setSortOption(event.target.value);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 2,
            width: "100%",
            // backgroundColor: "var(--dk-surface, #fff)",
            p: 2,
            borderRadius: "8px",
            transition: "background-color 0.2s ease-in-out",
            backgroundColor: "var(--dk-surface, white)",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.05)",
          }}
        >
          <FormControl>
            <InputLabel id="sort-label">{t("SortCriteria")}</InputLabel>
            <Select
              value={sortOption}
              onChange={handleSortChange}
              labelId="sort-label"
              label={t("SortCriteria")}
              sx={{
                "& .MuiSelect-select": {
                  padding: "10px",
                },
                width: "125px",
              }}
            >
              <MenuItem value="all">{t("All")}</MenuItem>
              {step === t("Classification") ? null : (
                <MenuItem value="class">{t("ClassOrder")}</MenuItem>
              )}
              <MenuItem value="accuracy">{t("AccuracyOrder")}</MenuItem>
            </Select>
          </FormControl>
          <Button
            variant="contained"
            sx={{ ...ContainedButtonStyles, height: "43px" }}
            onClick={() => setFilterModalOpen(true)}
          >
            <FilterListOutlinedIcon sx={{ color: "var(--icon-color)" }} />{" "}
            {t("Filter")}
          </Button>
          <IconButton
            onClick={() => {
              setFilterOption({});
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            width: "100%",
            justifyItems: "flex-end",
            mb: "5px",
            mr: "10px",
          }}
        >
          {sortOption === "all" && (
            <Typography variant="body2">
              {t("SortByTopAccuracyInfoMsg")}
            </Typography>
          )}
        </Box>
        <TableContainer sx={{ height: "500px", overflow: "auto" }}>
          <Table>
            <TableHead
              sx={{
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "var(--history-table-header)",
              }}
            >
              <TableRow>
                {columns.map((column) => (
                  <TableCell sx={{ color: "var(--text-color)" }}>
                    {column.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody
              sx={{ "& .MuiTableCell-root": { color: "var(--ht-color)" } }}
            >
              {historyData.length > 0 ? (
                historyData.map((row) => (
                  <TableRow
                    onClick={() => handlePointClick(row.id)}
                    sx={{
                      backgroundColor:
                        selectedRow.id === row.id
                          ? "rgba(75, 192, 192, 0.1)"
                          : row.top
                          ? "var(--selected-row-bg)"
                          : "var(--unselected-row-bg)",
                      "&:hover": {
                        backgroundColor: row.top
                          ? "rgba(255, 215, 0, 0.05)"
                          : "rgba(75, 192, 192, 0.05)",
                        cursor: "pointer",
                      },
                    }}
                  >
                    <TableCell>{row.id}</TableCell>
                    <TableCell>
                      {row.class_name.includes("[")
                        ? t("IntegratedModel")
                        : row.class_name}
                    </TableCell>
                    <TableCell>{formatDateTime(row.create_at)}</TableCell>
                    <TableCell>
                      {row.finish_at ? formatDateTime(row.finish_at) : "-"}
                    </TableCell>
                    {/* <TableCell>
                    {getTimeDiff(row.create_at, row.finish_at)}
                  </TableCell> */}
                    <TableCell>{row.imageCount}</TableCell>
                    <TableCell>
                      <AccuracyBar
                        accuracy={row.accuracy ? row.accuracy * 100 : 0}
                      />
                    </TableCell>
                    <TableCell>{row.epoch}</TableCell>
                    <TableCell>
                      <span
                        style={{
                          ...statusStyles(row.status),
                          padding: "5px",
                          borderRadius: "5px",
                        }}
                      >
                        {row.status}
                      </span>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={columns.length}
                    sx={{ textAlign: "center" }}
                  >
                    {t("NoDataMsg")}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      {historyData.length > 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 2,
            mb: 2,
            borderRadius: "8px",
            transition: "background-color 0.2s ease-in-out",
            backgroundColor: "var(--dk-surface, white)",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.05)",
            p: 2,
            height: "100%",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              mb: 2,
            }}
          >
            <Typography
              sx={{
                color: "#1E40AF",
                bgcolor: "#DBEAFE",
                borderRadius: "5px",
                p: 1,
              }}
            >
              {t("SelectedRound")}:{" "}
              {selectedRow.id === -1 ? "-" : selectedRow.id}
            </Typography>
            <LineChartComponent
              data={historyData.length > 0 ? historyData : []}
              onPointClick={handlePointClick}
            />
          </Box>

          {accuracyData.length > 0 && (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                mb: 2,
              }}
            >
              <Typography
                sx={{
                  color: "#1E40AF",
                  bgcolor: "#DBEAFE",
                  borderRadius: "5px",
                  p: 1,
                }}
              >
                {t("SelectedEpoch")}:{" "}
                {selectedEpoch
                  ? selectedEpoch?.epoch +
                    " / " +
                    t("Accuracy") +
                    ": " +
                    selectedEpoch?.accuracy * 100 +
                    "%"
                  : "-"}
              </Typography>
              <LineChartComponent2
                data={accuracyData}
                setSelectedEpoch={setSelectedEpoch}
              />
              {accuracyData.length > 0 && (
                <Button
                  variant="contained"
                  sx={{
                    ...ContainedButtonStyles,
                    ml: 5,
                    width: "90%",
                    height: "40px",
                  }}
                  onClick={handleContinueTraining}
                >
                  {t("ContinueTraining")}
                </Button>
              )}
            </Box>
          )}
        </Box>
      )}
      {filterModalOpen && (
        <TrainHistoryFilterModal
          open={filterModalOpen}
          onClose={() => setFilterModalOpen(false)}
          filterOption={filterOption}
          setFilterOption={setFilterOption}
        />
      )}
    </>
  );
}

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles("dark", {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
    ...theme.applyStyles("dark", {
      backgroundColor: "#308fe8",
    }),
  },
}));

function AccuracyBar({ accuracy }: { accuracy: number | null }) {
  return (
    <>
      {accuracy ? (
        <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
          <span style={{ marginRight: "10px", minWidth: "50px" }}>
            {accuracy ? `${accuracy}%` : "-"}
          </span>
          <div style={{ flex: 1 }}>
            <BorderLinearProgress variant="determinate" value={accuracy} />
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
